jQuery(document).on('change', '#support_country', function() {
    let url = '',
        country = jQuery(this).val(),
        linkContainer = jQuery("#link_to_support");
    url = country === "Other" ? linkContainer.data('other') : linkContainer.data('url');
    linkContainer.attr('href', url);
    country === "France" ? jQuery(".french-support").addClass('active') : jQuery(".french-support").removeClass('active');
});
jQuery( document ).ready(function() {
    setTimeout(()=>{
        if (jQuery('#support_country').val() === 'France') {
            jQuery(".french-support").addClass('active');
        }
    }, 500)
});
